<template>
  <div>
    <div class="page-header bordered">
      <h1>My profile</h1>
    </div>

    <form data-vv-scope="basic-information">
      <ShowErrors
        :errorMessages="errorMessages"
      />

      <h3 class="subheadline">Basic Information</h3>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="first_name" class="required">First Name</label>
            <input type="text" v-model="user.first_name" name="first_name"
              class="form-control form-control-lg" v-validate="'required|min:3'"
              data-vv-as="first name" />
            <span v-show="errors.has('basic-information.first_name')" class="input-error">
              {{ errors.first('basic-information.first_name') }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="last_name" class="required">Last Name</label>
            <input type="text" v-model="user.last_name" name="last_name"
              class="form-control form-control-lg" v-validate="'required|min:3'"
              data-vv-as="last name" />
            <span v-show="errors.has('basic-information.last_name')" class="input-error">
              {{ errors.first('basic-information.last_name') }}
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="email" class="required">Your Email</label>
        <input type="email" name="email" class="form-control form-control-lg"
          v-model="user.email" v-validate="'required|email'" data-vv-as="email">
        <span v-show="errors.has('basic-information.email')" class="input-error">
          {{ errors.first('basic-information.email') }}
        </span>
      </div>

      <div v-show="user.confirmed_at === null" class="row">
        <div class="col-md-12">
          <div class="alert alert-warning" role="alert">
            Your email is not confirmed. Please check your inbox.
            <br/>
            <a href="javascript:;" class="added-by" v-on:click="resendConfirmationInstructions();">
              Resend confirmation
            </a>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="phone_number" class="required">Phone Number</label>
            <input type="text" v-model="user.phone_number" name="phone_number"
              v-validate="'required|numeric|length:10'"
              data-vv-as="phone number"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.phone_number')" class="input-error">
              {{ errors.first('basic-information.phone_number') }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="form-group">
            <label for="address" class="required">Address</label>
            <input type="text" v-model="user.address" name="address"
              v-validate="'required'"
              data-vv-as="address"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.address')" class="input-error">
              {{ errors.first('basic-information.address') }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="city" class="required">City</label>
            <input type="text" v-model="user.city" name="city"
              v-validate="'required'"
              data-vv-as="city"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.city')" class="input-error">
              {{ errors.first('basic-information.city') }}
            </span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="state" class="required">State</label>
            <input type="text" v-model="user.state" name="state"
              v-validate="'required'"
              data-vv-as="state"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.state')" class="input-error">
              {{ errors.first('basic-information.state') }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for="country" class="required">Country</label>
            <input type="text" v-model="user.country" name="country"
              v-validate="'required'"
              data-vv-as="country"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.country')" class="input-error">
              {{ errors.first('basic-information.country') }}
            </span>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for="zip_code" class="required">Zipcode</label>
            <input type="text" v-model="user.zip_code" name="zip_code"
              v-validate="'required|numeric'"
              data-vv-as="zip code"
              class="form-control form-control-lg" />
            <span v-show="errors.has('basic-information.zip_code')" class="input-error">
              {{ errors.first('basic-information.zip_code') }}
            </span>
          </div>
        </div>
      </div>
      <hr>
      <div class="form-group action">
        <button type="button" class="btn btn-lg btn-primary"
          v-on:click="validate('basic-information')">
          Update Profile
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import ShowErrors from '../common/ShowErrors'

export default {
  name: 'Profile',
  components: {
    ShowErrors
  },
  data () {
    return {
      user: {
        id: null,
        email: null,
        first_name: null,
        last_name: null,
        address: null,
        zip_code: null,
        city: null,
        state: null,
        country: null,
        phone_number: null,
        confirmed_at: null
      },
      errorMessages: []
    }
  },
  created () {
    var self = this
    var userId = this.$localStorage.get('user_reference')

    this.$http.get('users/' + userId).then(function (response) {
      self.user = response.data
    })
  },
  methods: {
    validate (scope) {
      var self = this

      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          self.updateProfile()
        }
      })
    },
    updateProfile: function () {
      var self = this

      this.$http.put('/users/' + this.user.id, { user: this.user }).then(function (response) {
        self.errorMessage = ''

        self.$swal({
          title: 'Profile updated!',
          type: 'success'
        })
      }).catch(function (error) {
        if (error) {
          self.errorMessages = error.response.data.message

          self.$swal({
            title: 'Error updating profile',
            text: 'Please, check errors in form',
            type: 'error'
          })
        }
      })
    },
    resendConfirmationInstructions: function () {
      var self = this

      self.$swal.fire({
        title: 'Resend confirmation instructions?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes'
      }).then((result) => {
        if (result.value) {
          this.$http.post('/users/' + this.$localStorage.get('user_reference') + '/resend_confirmation_instructions')
            .then(function (response) {
              self.errorMessage = ''
              self.user.password = null
              self.user.new_password = null
              self.user.confirm_password = null

              self.$swal({
                title: 'Confirmation instructions sent!',
                text: 'Please, check your inbox.',
                type: 'success'
              })
            }).catch(function (error) {
              if (error) {
                var errorMsg = error.response.data.message || error.response.data.error
                self.errorMessages.push(errorMsg)

                self.$swal({
                  title: 'Error updating password',
                  text: 'Please, check errors in form',
                  type: 'error'
                })
              }
            })
        }
      })
    }
  }
}
</script>
